module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QEMEB0J/OyDRwAAARpJREFUSMftlq1OBDEUhb9CEaxgkoJAYHiHKgRPQFAkqF2Hx/YJKggWgdhk5RreggTRd0ATkiaEhDCTzBRTMZkFtstP1/So9k5vvtwzR1yhjT8HbgBFHj0Dl0IbXwNbwDsQMoC3gU4CEngF9oH2P4nOqkYb74Ed2as3zqo2k91ssCYVcAEXcAEXcAEX8AI4ZFwCAr21p9LGh5wTS+AUmK1g+x4wGtSegDqxvwHGAkAbLwCR2DgHzga1Y+A+1WpnVZBx+wupq+0Xv6RzVnV/mmpt/LD0WQjrJT0LEolT3gJH8XoAVIMnj8AbsAlcOaumKeFK0cWS74e98zUw/dXE0bJJTH2qWmAXeHFW/dxqbfxdTO0qOnFWPXz34AOPvUmsZl6yGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop-icon.png
// module id = 363
// module chunks = 1